module.exports = __webpack_public_path__ + "img/kp47hover.93aa3c34.png";